import { get } from './apiUtils';

const defaultUrl = '/FormulaReviewsMissingDocument/';
const changeStatus = '/ChangeStatus/';

export default {
  changeStatus: data => get(`${defaultUrl}${data.id}${changeStatus}${data.status}`),
};
